import { type SetupIntentResource } from '@/features/billing/api/resources/billing-method'
import { type SetupIntent } from './SetupIntent'

/**
 * Maps a Stripe setup intent for adding a payment method.
 */
export function mapSetupIntentResourceToSetupIntent(
  resource: SetupIntentResource,
): SetupIntent {
  return {
    setupIntentId: resource.setup_intent_id,
    clientSecret: resource.client_secret,
  }
}
